export const FINGERPRINTABLE_METADATA = 'fingerprintable';
//# sourceMappingURL=constant.js.map